import { Badge } from "@/components/ui/badge";
import { CheckCircle, MagnifyingGlass, WarningCircle } from "@phosphor-icons/react";

export const BooPicker = ({ boos, loading, query, onQuery, selected, onSelect, testid = "routing-boo" }) => (
  <div className="space-y-2" data-testid={`${testid}-picker`}>
    <div className="relative max-w-sm">
      <MagnifyingGlass size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#98A2B3]" />
      <input
        value={query}
        onChange={(e) => onQuery(e.target.value)}
        placeholder="Search by ID, e.g. ZZTEST"
        data-testid={`${testid}-search`}
        className="w-full h-9 rounded-lg border border-[#D0D5DD] pl-9 pr-3 text-[13px] outline-none focus:border-[#0E7C86] focus:ring-1 focus:ring-[#0E7C86] transition-colors"
      />
    </div>

    {loading && <p className="text-[12px] text-[#667085]">Reading the bills of operations from SAP…</p>}

    <div className="max-h-64 overflow-y-auto rounded-lg border border-[#D0D5DD] bg-white divide-y divide-[#F2F4F7]">
      {!loading && !boos.length && (
        <p className="px-3 py-3 text-[12px] text-[#667085]">Nothing in SAP matches that.</p>
      )}
      {boos.map((boo) => (
        <button
          key={boo.boo_id}
          type="button"
          onClick={() => onSelect(boo.boo_id)}
          data-testid={`${testid}-${boo.boo_id}`}
          className={`w-full text-left px-3 py-2 transition-colors ${
            selected === boo.boo_id ? "bg-[#F0F9FF]" : "hover:bg-[#FCFCFD]"
          }`}
        >
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-mono text-[12px] font-semibold text-[#1D2939]">{boo.boo_id}</span>
            <Badge
              variant="outline"
              className={`text-[10px] ${
                boo.consistent
                  ? "bg-[#ECFDF3] text-[#027A48] border-[#ABEFC6]"
                  : "bg-[#FEF3F2] text-[#B42318] border-[#FECDCA]"
              }`}
            >
              {boo.consistent ? <CheckCircle size={10} weight="fill" /> : <WarningCircle size={10} weight="fill" />}
              <span className="ml-1">
                {boo.consistent ? "consistent" : `${boo.planning_consistency_label} / ${boo.execution_consistency_label}`}
              </span>
            </Badge>
            {boo.description && (
              <span className="text-[11px] text-[#667085] truncate">{boo.description}</span>
            )}
          </div>
        </button>
      ))}
    </div>
  </div>
);
